import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class PlanningDashboardOverviewTableRoute extends Route {
  @service store;
  @service roadmap;

  defaultStatus = [
    'ACTIVE',
    'READY',
    'READY FOR PLANNING',
    'DISCOVERY',
    'DRAFT',
  ];

  queryParams = {
    status: {
      refreshModel: false,
    },
    sources: {
      refreshModel: false,
    },
    productManagers: {
      refreshModel: false,
    },
    themes: {
      refreshModel: false,
    },
    teams: {
      refreshModel: false,
    },
    roadmaps: {
      refreshModel: false,
    },
  };

  teams = [];
  persons = [];

  beforeModel() {
    const promises = [
      this.store.findAll('theme'),
      this.store.findAll('person'),
      this.store.findAll('team'),
      this.store.findAll('goal'),
      this.store.findAll('role'),
      this.store.findAll('roadmap'),
    ];
    return Promise.all(promises).then(([, persons, teams]) => {
      this.persons = persons;
      this.teams = teams;
    });
  }

  model(params) {
    const _params = { ...params };
    delete _params['columns'];
    delete _params['grouping'];
    if (_params.status == undefined || _params.status.length === 0)
      _params.status = this.defaultStatus;
    return RSVP.hash({
      initiatives: this.store.query('initiative', {
        ..._params,
        include: 'workstream',
      }),
      roadmap: this.modelFor('planning.dashboard'),
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    if (controller.get('statuses').length === 0) {
      controller.set('statuses', this.defaultStatus);
    }

    if (!controller.get('grouping')) {
      controller.set('grouping', 'statuses');
    }

    if (controller.get('columns').length === 0) {
      const columns = controller.get('columnOptions').reduce((acc, item) => {
        if (item.show === undefined) acc.push(item.label);
        else if (item.show === true) acc.push(item.label);
        return acc;
      }, []);
      controller.set('columns', columns);
    }

    controller.set('persons', this.persons);
    controller.set('teamOptions', this.teams);
    controller.set('list', model);
  }
}

export default instrumentRoutePerformance(PlanningDashboardOverviewTableRoute);
